import { getDictPhrase } from "../../../common";
export const getMarketResultProps = (selection, state) => {
    return selection.gameScore
        ? {
            phrase: getDictPhrase(state.dict, "MarketResult"),
            resultText: selection.gameScore || ""
        }
        : undefined;
};
//# sourceMappingURL=getMarketResultProps.js.map